import { ADD_EVENT_TO_COLLECTION, CREATE_COLLECTION, REMOVE_EVENT_FROM_COLLECTION, REACH_MAX_LIMIT } from './actionTypes';
import { ADD_TO_COLLECTION_GA_ACTION, REMOVE_FROM_COLLECTION_GA_ACTION, REACHED_MAX_EVENTS_GA_ACTION, CREATE_COLLECTION_GA_ACTION } from './constants';
export var trackCreateCollection = function trackCreateCollection(id, category) {
  return {
    type: CREATE_COLLECTION,
    meta: {
      analytics: {
        action: CREATE_COLLECTION_GA_ACTION,
        label: id,
        category: category
      }
    }
  };
};
export var trackAddToCollection = function trackAddToCollection(id, category) {
  return {
    type: ADD_EVENT_TO_COLLECTION,
    meta: {
      analytics: {
        action: ADD_TO_COLLECTION_GA_ACTION,
        label: id,
        category: category
      }
    }
  };
};
export var trackRemoveFromCollection = function trackRemoveFromCollection(id, category) {
  return {
    type: REMOVE_EVENT_FROM_COLLECTION,
    meta: {
      analytics: {
        action: REMOVE_FROM_COLLECTION_GA_ACTION,
        label: id,
        category: category
      }
    }
  };
};
export var trackMaxEventAdded = function trackMaxEventAdded(id, category) {
  return {
    type: REACH_MAX_LIMIT,
    meta: {
      analytics: {
        action: REACHED_MAX_EVENTS_GA_ACTION,
        label: id,
        category: category
      }
    }
  };
};